var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"60px"}},[(_vm.loading)?_c('div',{staticClass:"la-ball-clip-rotate la-2x",staticStyle:{"color":"#79bbb5","margin":"0 auto"}},[_c('div')]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }